import React, { useState, useEffect } from "react";
import AproposCard from "./AproposCard";
import store2 from "../Assets/store2.png";
import myLogo from "../Assets/balagne-medical.png";
import logoCapvital from "../Assets/logo_capvital.gif";
import "../Styles/Apropos.css";
import ScrollToTop from "../Components/ScrollToTop.js";
import { Link } from "react-router-dom";

function Apropos() {
  const [patients, setPatients] = useState(0);
  const [professionals, setProfessionals] = useState(0);
  const [years, setYears] = useState(0);
  const [startedCounting, setStartedCounting] = useState(false);

  useEffect(() => {
    const section = document.getElementById("apropos");
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedCounting) {
          setStartedCounting(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, [startedCounting]);

  useEffect(() => {
    if (!startedCounting) return;

    const duration = 3500;
    const stepTime = 50;

    const animateCounter = (target, setter) => {
      const step = target / (duration / stepTime);

      let current = 0;

      const interval = setInterval(() => {
        current += step;

        if (current >= target) {
          clearInterval(interval);
          setter(target);
        } else {
          setter(Math.floor(current));
        }
      }, stepTime);

      return interval;
    };

    const patientsInterval = animateCounter(17000, setPatients);
    const professionalsInterval = animateCounter(70, setProfessionals);
    const yearsInterval = animateCounter(21, setYears);

    return () => {
      clearInterval(patientsInterval);
      clearInterval(professionalsInterval);
      clearInterval(yearsInterval);
    };
  }, [startedCounting]);

  return (
    <div className="Apropos-section" id="apropos">
      <ScrollToTop />

      <div className="Apropos-title-content">
        <h3 className="Apropos-title">
          <span>BMS c'est :</span>
        </h3>

        <p className="Apropos-description">
          Une entreprise qui intervient auprès des particuliers,
          des professionnels de la santé, des collectivités,
          des hôpitaux, des unités de soins, et des EPHAD.
        </p>
      </div>

      <div className="text-stats">
        <div className="text-stats-container">
          <p>{patients.toLocaleString("fr-FR")}</p>
          <p>Patients accompagnés</p>
        </div>

        <div className="text-stats-container">
          <p>{professionals}</p>
          <p>Professionnels de santé nous font confiance</p>
        </div>

        <div className="text-stats-container">
          <p>{years}</p>
          <p>Années d'expérience</p>
        </div>
      </div>

      <div className="Apropos-cards-content">
        <AproposCard
          title="Matériels Particuliers"
          description="Location et vente de lits, de fauteuils roulants. Produits d'hygiène et incontinence, nutrition, confort et bien-être, produits d'allaitement."
          button={{
            label: "Particuliers",
            to: "/particuliers",
            component: Link,
          }}
        />

        <AproposCard
          title="Matériels Professionnels"
          description="Matériels dédiés aux professionnels de santé : lingettes, sprays, gants, tensiomètres, otoscopes, ciseaux & pinces, pansements, perfusion, compresses, etc."
          button={{
            label: "Professionnels",
            to: "/professionnels",
            component: Link,
          }}
        />

        <AproposCard
          title="Livraison & Installation"
          description="Une équipe de livraison dédiée pouvant intervenir très rapidement, et mettre en place le matériel directement chez vous."
        />
      </div>

      <img
        className="Apropos-image2"
        src={store2}
        alt="store2"
        width="1330"
        height="856"
      />

      <div className="partner-text">
        <img
          src={myLogo}
          alt="Balagne Medical Service"
          className="logo-bms"
          width="133"
          height="100"
        />
        <p>est partenaire de :</p>
      </div>

      <div className="logo-capvital-container">
        <img
          src={logoCapvital}
          alt="Logo Capvital"
          className="logo-capvital"
          width="292"
          height="70"
        />
      </div>
    </div>
  );
}

export default Apropos;
